/*
<ShipToAddressForm
    errors={this.state.toAddressErrors}
    fields={this.state.toAddressData}
    provinceList={this.state.provinceList}
    handleChange={(key, value) => this.setState({
        toAddressData: {...this.state.toAddressData, [key]: value},
        toAddressErrors: {...this.state.toAddressErrors, [key]: false},
    })}
/>
*/
import React from 'react'
import TextField from '@material-ui/core/TextField/TextField'
import { strings } from '../../localization/strings'
import FormLabel from '@material-ui/core/FormLabel/FormLabel'
import SelectSimple from './selectSimple'

const style = {
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
    },
    page: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 500,
        margin: 'auto',
        padding: '20px 10px',
    },
    field: { marginTop: 15, flexGrow: 1 },
    option: { marginTop: 15, marginLeft: 25 },
}

const formatReq = (string) => (
    <div>
        {string}
        <span style={{ color: 'red' }}> *</span>
    </div>
)

const Component = ({ handleChange, errors, fields, provinceList }) => {
    return (
        <div
            style={{ border: '2px solid #f7b500', borderRadius: 8, padding: 8 }}
        >
            <TextField
                label={formatReq(strings.contactName)}
                placeholder={strings.contactNamePlaceholder}
                value={fields.name}
                error={errors.name}
                // helperText={helperText.name}
                onChange={(x) => handleChange('name', x.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
                style={style.field}
            />

            <div style={style.field} />
            <div style={style.field} />

            <FormLabel component="legend">{strings.orderNewAddress}</FormLabel>

            <TextField
                label={formatReq(strings.streetAddress)}
                placeholder={strings.streetAddressPlaceholder}
                value={fields.streetAddress}
                error={errors.streetAddress}
                // helperText={helperText.streetAddress}
                onChange={(x) => handleChange('streetAddress', x.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
                style={style.field}
            />

            <TextField
                label={formatReq(strings.streetNumber)}
                placeholder={strings.streetNumberPlaceholder}
                value={fields.streetNumber}
                error={errors.streetNumber}
                // helperText={helperText.streetNumber}
                onChange={(x) => handleChange('streetNumber', x.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
                style={style.field}
            />

            <TextField
                label={strings.addressInfoDialogFloor}
                placeholder={strings.floorPlaceholder}
                value={fields.floor}
                error={errors.floor}
                // helperText={helperText.floor}
                onChange={(x) => handleChange('floor', x.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
                style={style.field}
            />

            <TextField
                label={strings.addressInfoDialogApartment}
                placeholder={strings.apartmentPlaceholder}
                value={fields.apartment}
                error={errors.apartment}
                // helperText={helperText.apartment}
                onChange={(x) => handleChange('apartment', x.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
                style={style.field}
            />

            <TextField
                label={strings.addressInfoDialogLocality}
                placeholder={strings.localityPlaceholder}
                value={fields.locality}
                error={errors.locality}
                // helperText={helperText.locality}
                onChange={(x) => handleChange('locality', x.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
                style={style.field}
            />

            <TextField
                label={formatReq(strings.city)}
                placeholder={strings.cityPlaceholder}
                value={fields.city}
                error={errors.city}
                // helperText={helperText.city}
                onChange={(x) => handleChange('city', x.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
                style={style.field}
            />

            <SelectSimple
                label={formatReq(strings.province)}
                options={provinceList}
                openUp={true}
                selectedOption={fields.province}
                valueTag={'id'}
                labelTag={'name'}
                style={style.field}
                error={errors.province}
                handleChange={(x) => handleChange('province', x)}
            />
        </div>
    )
}

export default Component